module.exports = __webpack_public_path__ + "img/vray.0de2f974.svg";